import React from 'react';
import {
  IconAlarmPlus,
  IconArrowLeft,
  IconArrowsDiff,
  IconClipboardCheck,
  IconClock,
  IconDeviceAnalytics,
  IconFolder,
  IconGps,
  IconHourglassEmpty,
  IconInfoCircle,
  IconPremiumRights,
  IconShieldCheck,
  IconShieldSearch,
  IconTableExport,
  IconTool,
  IconUser,
} from '@tabler/icons-react';
import { INavigationMenu } from 'src/app/navigation/navigationTypes';

export const mainItems: INavigationMenu = {
  items: [
    {
      id: 'group-dashboard',
      title: 'Organization',
      type: 'group',
      children: [
        {
          id: 'ctc',
          title: 'CTC',
          type: 'item',
          url: '/ctc',
          icon: <IconPremiumRights size={22} />,
          requiredScopes: ['modules_all', 'ctc'],
        },
        {
          id: 'jobs',
          title: 'Jobs',
          type: 'item',
          url: '/jobs',
          requiredScopes: ['modules_all', 'jobs'],
          icon: <IconFolder size={22} />,
        },
        {
          id: 'changes',
          title: 'Changes',
          type: 'item',
          url: '/changes',
          requiredScopes: ['modules_all', 'changes'],
          icon: <IconArrowsDiff size={22} />,
        },
        {
          id: 'rfis',
          title: 'RFIs',
          type: 'item',
          url: '/rfis',
          requiredScopes: ['modules_all', 'rfis'],
          icon: <IconInfoCircle size={22} />,
        },
        {
          id: 'inspections',
          title: 'Inspections',
          type: 'item',
          url: '/inspections',
          requiredScopes: ['modules_all', 'inspections'],
          icon: <IconClipboardCheck size={22} />,
        },
        {
          id: 'service_work',
          title: 'Service Work',
          type: 'item',
          requiredScopes: ['modules_all', 'service_work', 'service_work_all'],
          url: '/service-work',
          icon: <IconTool size={22} />,
        },
        {
          id: 'safety',
          title: 'Safety',
          type: 'item',
          url: '/safety',
          requiredScopes: ['modules_all', 'safety'],
          icon: <IconShieldCheck size={22} />,
        },
        {
          id: 'analytics',
          title: 'Data Analytics',
          type: 'item',
          url: '/analytics',
          requiredScopes: ['modules_all', 'analytics'],
          icon: <IconDeviceAnalytics size={22} />,
        },
        {
          id: 'activity_feed',
          title: 'Activity Feed',
          type: 'item',
          requiredScopes: ['modules_all', 'activity_feed'],
          url: '/activity',
          icon: <IconAlarmPlus size={22} />,
        },
        {
          id: 'operations',
          title: 'Operations',
          type: 'item',
          url: '/operations',
          requiredScopes: ['modules_all', 'operations'],
          icon: <IconGps size={22} />,
        },
        {
          id: 'time',
          title: 'Time',
          type: 'item',
          url: '/time',
          requiredScopes: ['modules_all', 'time'],
          icon: <IconClock size={22} />,
        },
        {
          id: 'reports',
          title: 'Reports',
          type: 'item',
          url: '/reports',
          requiredScopes: ['modules_all', 'reports'],
          icon: <IconTableExport size={22} />,
        },
        {
          id: 'manhours',
          title: 'Manhours',
          type: 'item',
          requiredScopes: ['modules_all', 'manhours'],
          url: '/manhours',
          icon: <IconHourglassEmpty size={22} />,
        },
      ],
    },
  ],
};

export const accountItems: INavigationMenu = {
  items: [
    {
      id: 'back-settings',
      type: 'group',
      children: [
        {
          allowAll: true,
          id: 'back',
          title: 'Back to Dashboard',
          type: 'item',
          url: '/ctc',
          icon: <IconArrowLeft size={22} />,
          keepDrawerOpen: true,
        },
      ],
    },
    {
      id: 'group-account',
      title: 'Account',
      type: 'group',
      children: [
        {
          id: 'profile',
          title: 'Profile',
          type: 'item',
          allowAll: true,
          url: '/account/profile',
          icon: <IconUser size={22} />,
        },
        {
          allowAll: true,
          id: 'permissions',
          title: 'Permissions',
          type: 'item',
          url: '/account/permissions',
          icon: <IconShieldSearch size={22} />,
        },
      ],
    },
  ],
};
